export const getButtonLabel = (hasForm) => {
  if (!hasForm) {
    return 'Angebot anfordern';
  }

  return hasForm === 'TEST_DRIVE' ? 'Probefahrt' : 'Werkstatttermin';
};
